// extracted by mini-css-extract-plugin
export var body = "styles-module--body--w58J0";
export var text = "styles-module--text--+JLTM";